var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { StandardType } from '../../../enums/standard-type';
import { BasketUpdater } from '../../../logic/basket/basket-updater';
import { Router } from '@angular/router';
import swal from 'sweetalert';
var FunctionalSkillsComponent = /** @class */ (function () {
    function FunctionalSkillsComponent(basketUpdater, toastr, router) {
        this.basketUpdater = basketUpdater;
        this.toastr = toastr;
        this.router = router;
        this.weblinkData = [];
        this.viewModel = {
            formHeader: {
                pageHeader: 'Functional Skills',
                searchTitle: 'Search'
            },
            searchPlaceholder: 'Search by Title or Code',
            searchType: StandardType.FunctionalSkill,
            criteriaTypeRadio: null,
            selectedStandards: new Array(),
            addToBasketText: 'ADD TO BASKET',
            fullCriteriaTextValue: 'Full criteria',
            singleTickBoxTextValue: 'Single tick-box'
        };
    }
    FunctionalSkillsComponent.prototype.onResultSelected = function (standard) {
        this.addStandardToList(standard);
    };
    FunctionalSkillsComponent.prototype.toggleCriteriaType = function (value) {
        this.viewModel.criteriaTypeRadio = value;
    };
    FunctionalSkillsComponent.prototype.dismissSelectedStandard = function (standard) {
        this.removeStandardFromList(standard.id);
        this.viewModel.criteriaTypeRadio = null;
    };
    FunctionalSkillsComponent.prototype.isFormValid = function () {
        return this.viewModel.selectedStandards.length > 0 && this.viewModel.criteriaTypeRadio !== null;
    };
    FunctionalSkillsComponent.prototype.onWeblinkEvent = function ($event) {
        this.weblinkData = $event;
    };
    FunctionalSkillsComponent.prototype.addToBasket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, standard, functionalSkillsStandard;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.weblinkData[this.weblinkData.length - 1] == '') {
                            this.weblinkData.pop();
                        }
                        _i = 0, _a = this.viewModel.selectedStandards;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        standard = _a[_i];
                        functionalSkillsStandard = {
                            standard: standard,
                            attachedFile: [],
                            fileNames: [],
                            blobFileNames: [],
                            weblinkArray: [],
                            criteriaType: this.viewModel.criteriaTypeRadio
                        };
                        functionalSkillsStandard.weblinkArray = this.weblinkData;
                        return [4 /*yield*/, this.basketUpdater.addStandard(functionalSkillsStandard, StandardType.FunctionalSkill)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.toastr.success('Qualification added to basket', 'Success!', {
                            timeOut: 3000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.clearForm();
                        return [2 /*return*/];
                }
            });
        });
    };
    FunctionalSkillsComponent.prototype.removeStandardFromList = function (standardId) {
        var listIndex = this.viewModel.selectedStandards.indexOf(this.viewModel.selectedStandards.filter(function (x) { return x.id === standardId; })[0]);
        this.viewModel.selectedStandards.splice(listIndex, 1);
    };
    FunctionalSkillsComponent.prototype.addStandardToList = function (standard) {
        this.viewModel.selectedStandards.push(standard);
    };
    FunctionalSkillsComponent.prototype.clearForm = function () {
        this.viewModel.selectedStandards = new Array();
    };
    FunctionalSkillsComponent.prototype.openDialog = function () {
        var _this = this;
        swal({
            title: 'Are you sure? You will lose anything you have added for this request',
            icon: 'warning',
            buttons: ['No', 'Yes']
        }).then(function (clickedYes) {
            if (clickedYes) {
                _this.toastr.success('', 'Request Cancelled', {
                    timeOut: 3000,
                    positionClass: 'toast-bottom-right'
                });
                _this.router.navigate(['/request-standard']);
            }
        });
    };
    FunctionalSkillsComponent = __decorate([
        Component({
            selector: 'functional-skills',
            template: require('./functional-skills.component.html'),
            styles: [require('./functional-skills.component.scss')]
        }),
        __metadata("design:paramtypes", [BasketUpdater,
            ToastrService,
            Router])
    ], FunctionalSkillsComponent);
    return FunctionalSkillsComponent;
}());
export { FunctionalSkillsComponent };
//# sourceMappingURL=data:application/json;base64,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